<template>
	<div style="width: 100%;" class="d-flex">
		<div style="width: 33%;">
			<div style="width: 100%;" class="d-flex a-center">
				<div style="width:12%;font-size: 14px;text-align: right;padding-right: 10px;">* 姓名</div>
				<el-input v-model="form.title" placeholder="姓名" size="mini"></el-input>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:12%;font-size: 14px;text-align: right;padding-right: 18px;">性别</div>
				<el-button-group>
					<el-button type="primary" size="mini" @click="openModel(scope)" plain>男</el-button>
					<el-button type="danger" size="mini" @click="deleteItem(scope.row)" plain>女</el-button>
				</el-button-group>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:12%;font-size: 14px;text-align: right;padding-right: 10px;">座机</div>
				<el-input v-model="form.title" size="mini"></el-input>
			</div>
		</div>
		<div style="width: 33%;margin-left: 6px;">
			<div style="width: 100%;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;">* 登录账号</div>
				<el-input v-model="form.title" placeholder="姓名" size="mini"></el-input>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;text-align: right;padding-right: 10px;">身份证号</div>
				<el-input v-model="form.title" size="mini"></el-input>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;text-align: right;padding-right: 10px;">邮箱</div>
				<el-input v-model="form.title" size="mini"></el-input>
			</div>
		</div>
		<div style="width: 33%;margin-left: 6px;">
			<div style="width: 100%;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;">* 登录密码</div>
				<el-input v-model="form.title" placeholder="姓名" size="mini"></el-input>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;text-align: right;padding-right: 10px;">手机</div>
				<el-input v-model="form.title" size="mini"></el-input>
			</div>
			<div style="width: 100%;margin-top: 30px;" class="d-flex a-center">
				<div style="width:16%;font-size: 14px;text-align: right;padding-right: 10px;">所属部门</div>
				<el-input v-model="form.title" size="mini"></el-input>
			</div>
		</div>
	</div>
</template>

<script>
	import buttonSearch from "@/components/common/button-search.vue" // 引入 按钮、搜索、高级搜索组件
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	export default {
		inject:['layout'],
		mixins:[common], // 引入mixins里的common.js
		// 引入注册
		components: {
			buttonSearch
		},
		data() {
			return {
				preUrl:"notice",
				
				tableData: [],
				
				createModel:false,
				editIndex:-1,
				
				form:{
					title:"",
					content:""
				},
				rules:{
					title:[{ 
						required:true,
						message:"公告标题不能为空",
						trigger:'blur' ,
					}],
					content:[{
						required:true,
						message:"公告内容不能为空",
						trigger:'blur' ,
					}],
				}
			}
		},
		methods: {
			getListResult(e){
				this.tableData = e.list
			},
			// 打开模态框
			openModel(e = false){
				// 增加
				if (!e) {
					// 初始化表单
					this.form = {
						title:"",
						content:""
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						title:e.row.title,
						content:e.row.content,
					}
					this.editIndex = e.$index
				}
				// 打开dialog
				this.createModel = true
			},
			// 添加规格
			submit(){
				this.$refs.form.validate(res=>{
					if (res) {
						let id = 0
						if (this.editIndex !== -1) {
							id = this.tableData[this.editIndex].id
						}
						this.addOrEdit(this.form,id)
						// 关闭模态框
						this.createModel = false
					}
				})
			},
		},
	}
</script>

<style>
	.j-center{
		justify-content: center;
	}
	.a-center{
		align-items: center;
	}
	.j-j{
		flex-flow: column;
	}
</style>
